import type { PublicIntegrationSnapshot } from '@frontend/context/publicIntegrationTypes';

export async function fetchPublicIntegrationConfig(): Promise<PublicIntegrationSnapshot> {
  const response = await fetch('/api/public-integration-config', { credentials: 'same-origin' });
  if (!response.ok) {
    throw new Error('Failed to load public integration config');
  }
  return (await response.json()) as PublicIntegrationSnapshot;
}
